var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DropDown',{attrs:{"loading":_vm.searching,"options":_vm.schools,"label":"full_name"},on:{"setData":_vm.setSchool,"setInput":_vm.setInput,"debounceInput":_vm.search}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }